import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/constants";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle } from "../components/site/Primitives";
import SEO from "../components/SEO";

const CATEGORIES = ["Todos", "Prótese capilar", "Calvície", "Manutenção", "Cuidados", "Barbearia", "Cortes masculinos", "Estilo masculino"];

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("Todos");

  useEffect(() => {
    api.get("/posts").then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => (cat === "Todos" ? posts : posts.filter((p) => p.category === cat)), [posts, cat]);

  return (
    <div>
      <SEO title="Blog | Prótese Capilar, Cuidados e Estilo Masculino" description="Artigos sobre prótese capilar, calvície, manutenção, cuidados, barbearia e estilo masculino." />

      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Blog</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Conteúdo e cuidado masculino</SectionTitle></Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-12 lg:py-16">
        <div className="flex flex-wrap gap-2.5 mb-10">
          {CATEGORIES.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c.toLowerCase().replace(/\s/g, "-")}`}
              className={`font-heading font-500 text-sm tracking-wide px-4 py-2 rounded-sm border transition-colors ${cat === c ? "bg-gold text-black border-gold" : "border-white/15 text-zinc-300 hover:border-white/40"}`}>
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.06}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-post-${p.slug}`} className="group block border border-white/10 rounded-sm overflow-hidden hover:border-gold/50 transition-colors h-full">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <span className="overline-label text-[10px] text-gold">{p.category}</span>
                  <h3 className="font-heading font-600 text-white text-lg mt-2 leading-snug">{p.title}</h3>
                  <p className="text-zinc-400 text-sm mt-2 leading-relaxed line-clamp-2">{p.excerpt}</p>
                  <span className="inline-flex items-center gap-1.5 text-gold text-sm font-heading mt-4 group-hover:gap-2.5 transition-all">Ler artigo <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        {filtered.length === 0 && <p className="text-zinc-500">Nenhum artigo nesta categoria ainda.</p>}
      </section>
    </div>
  );
}
